.flex {
  display: flex;
}
